
// Common handler for deleting resources (Resources and Services)
// The first public function is deleteResource, which takes the resource to delete, the RestComponent to use for fetches and alerts, and an onConfirm callback
//      the onConfirm callback is called once the user confirms they want to delete the resource and if there are any future events/bookings affected,
//      passing the resource and the if future events or bookings are affected..  The user should call doDeleteResource from that callback to actually do the delete.  
//
// The second public function is doDeleteResource, which takes the resource to delete, the RestComponent to use for fetches and alerts, and an onSuccess callback
//      this function actually does the delete, and calls onSuccess once complete.  The user call this if onConfirm from deleteResource is called.
//
// Internal functions handle the fetch callbacks and error handling
//
export class DeleteResourceHandler {

    static deleteResource = (resource, restComponent, onConfirm) => {
        restComponent.incrementBusy();
        restComponent.secureJSONFetch("/bk/resources/futureSlotCounts?resourceIDs=" + resource.id, {}, 
                             (response) => DeleteResourceHandler._deleteResourceGetCountCallback(response, resource, restComponent, onConfirm), 
                             (error) => DeleteResourceHandler._fetchErrorCallback(error, restComponent));
    }

   
   static _deleteResourceGetCountCallback = (response, resource, restComponent, onConfirm) => {
        restComponent.decrementBusy();
        
        if (!response) {
            console.error("No response from server");
            return;
        }

        let notice = "<span>Are you sure you want to delete \"" + resource.name + "\"? ";
        if (response.futureEventsAffected === 0 && response.futureBookingsAffected === 0 && response.futureEventsDeleted === 0 && response.futureBookingsDeleted === 0)
            notice += "There is nothing scheduled on this " + resource.type + " in the future that will be affected.</span>";
        else {

            let types = [];
            if (response.futureBookingsAffected > 0 || response.futureBookingsDeleted > 0)
                types.push("Bookings");
            if (response.futureEventsAffected > 0 || response.futureEventsDeleted > 0)
                types.push("Events");

            notice += "Either future or in-progress " + types.join(" and ") + " will be affected by deleting this " + resource.type + ". The following will occur:<br/>";
            notice += "<ul>";
            switch (resource.type) {
                case "Resource":
                    if (response.futureEventsAffected > 0)
                        notice += "<li>" + response.futureEventsAffected + " Events will have this Resource <span style='font-weight: bold'>removed</span>. Patrons are not notified.</li>";
                    if (response.futureEventsDeleted > 0)   
                        notice += "<li>" + response.futureEventsDeleted + " Events only use this Resource and will be <span style='color: red; font-weight: bold'>deleted/cancelled</span>. Patrons are notified.</li>";
                    if (response.futureBookingsAffected > 0)
                        notice += "<li>" + response.futureBookingsAffected + " Bookings will have this Resource <span style='font-weight: bold'>unassigned</span>. Patrons are not notified.</li>";
                    break;
                case "Service":
                    if (response.futureBookingsDeleted > 0)
                        notice += "<li>" + response.futureBookingsDeleted + " Bookings on this Service will be <span style='color: red; font-weight: bold'>cancelled</span>. Patrons are notified.</li>";
                    break;
                default:
                    console.error("Unknown resource type: " + resource.type);
                    return;
            }
            notice += "</ul></span>";
        }

        // The only ones we send a message to are those that are deleted
        const futureItemsDeleted = (response.futureEventsDeleted + response.futureBookingsDeleted) > 0;

        const msg = <div dangerouslySetInnerHTML={{ __html: notice }} />

        restComponent.showConfirmAlert("Delete " + resource.type, 
                                        null, 'black',
                                        "Cancel", 
                                        () => DeleteResourceHandler._deleteResourceConfirm(onConfirm, futureItemsDeleted, onConfirm),
                                        "Delete",
                                        'red',
                                        msg);
    }

    static _deleteResourceConfirm = (resource, futureItemsAffected, onConfirm) => {
        onConfirm(resource, futureItemsAffected);
    }


    static doDeleteResource = (resource, restComponent, notify, msg, onSuccess) => {

        const body = {notify: true, customMsg: msg};

        restComponent.incrementBusy();
        restComponent.secureJSONFetch("/bk/resources/" + resource.id, {method: 'PATCH', body: JSON.stringify(body)}, 
                                      () => DeleteResourceHandler._deleteComplete(resource, restComponent, onSuccess), 
                                      (error) => DeleteResourceHandler._fetchErrorCallback(error, restComponent));
    }

    static _deleteComplete = (resource, restComponent, onSuccess) => {
        restComponent.decrementBusy();
        if (onSuccess)
            onSuccess(resource);
    }

    static _fetchErrorCallback = (error, restComponent) => {
        restComponent.showConfirmAlert("Error", error, 'red');
        restComponent.decrementBusy();
    }

}